exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "section#photos{display:block;min-height:100vh;width:100vw;position:absolute;top:0;left:0;z-index:10;background-color:hsla(0,0%,100%,.95)}section#photos ul{width:100vw;padding:10rem 0;text-align:center}section#photos ul li{position:relative;margin:4rem;display:inline-block}section#photos ul li img{max-width:60rem;height:auto}section#photos h1#top{position:fixed;width:100vw;bottom:3rem;left:2rem;text-align:center}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./public/_src/_vue/Photos.vue
 ** module id = 8
 ** module chunks = 0
 **/